import { SiteViewConfiguration } from 'src/app/models/enums';

export const environment = {
  production: true,
  viewConfiguration: SiteViewConfiguration.NIGERIA,
  firebase: {
    apiKey: 'AIzaSyAL7d-AMzXOsF0CoVzBTC5rHRvTC5bNXGM',
    authDomain: 'sinadev-android-bet.firebaseapp.com',
    databaseURL: 'https://sinadev-android-bet.firebaseio.com',
    projectId: 'sinadev-android-bet',
    storageBucket: 'sinadev-android-bet.appspot.com',
    messagingSenderId: '191831481454',
    appId: '1:191831481454:web:bedfe522795d3530fe1a7f',
    measurementId: 'G-RQVKSJ3J0Q'
  },

  productVersion: '1.0.20260908234238',
  isMaintinanceBreak: false,

  baseURL: 'https://sport-shopapi.betwgb.com/api/',
  notificationServiceURL: 'https://webapi.betwgb.com',
  cacheChangesURL: 'https://sport-shopapi.betwgb.com/AffSportBookCache/api/',
  postMessageURL: 'https://shop.betwgb.com',
  sportBookBaseURL:  'https://sport-shopapi.betwgb.com/AffSportBookCache/api/',
  ticketManagerBaseURL:'https://shop.betwgb.com/api/',
  signalRBaseURL:'https://shop.betwgb.com/',
  useSportBookOffer: true,

  useMinCacheChanges: true,
  localDeploy: false,
  prodDepoly: true,
  betWebOfficeId: 1869,
  showBannersOnMobilePage: true,

  eventDateToSringFormatMobile: { weekday: 'short', month: '2-digit', day: '2-digit' },
  eventDateToSringFormatDesktop: { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' },
  ticketItemGroupDateToStringFormat: { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' },

  // only for sport named special (for ordering in tree)
  specialsSportId: 137,
  timeFilterOffset: 9,
  checkForLiveStream: false,
  reloadPageOnCommunicationError: false,
  myTicketsCount: 5,
  bannerSportId: 1,
  bannerRegionId: 1,
  bannerCompetitionId: 1,
  specialSportIds: [137],
  higlightedLeagueId: 114,
  predefinedDenominations: [],
  useSerparateMobileConfiguration: true,
  sportRadarName: 'winnersgoldenbet',
  chatRoomURL: '',
  chatRoomApiKey: '',
  isAffiliateSite:true
};
